import random from 'toxilibs/random.js'
import QuestionGeneratorHelper from '../core/question_generator_helper.js'

function digit () {
    return random.intBetween(1, 9)
}


QuestionGeneratorHelper.prototype.addBadChoices = function (...choices) {
    this.badChoices = this.badChoices || []

    choices.forEach((choice) => {
        if (Array.isArray(choice)) {
            this.addBadChoices(...choice)
        } else {
            if (choice === 'digit') {
                choice = digit
            }
            this.badChoices.push(choice)
        }
    })

}



